import { createContext } from "react"

import type { Report } from "../../types/generated/api/Report"

/**
 * React Context for sharing Report data throughout the Insights feature
 * @type {React.Context<{report: Report | undefined}>}
 *
 * The context provides:
 * - report: The current Report object or undefined if no report is loaded
 *
 * @example
 * // To use this context:
 * const { report } = useContext(ReportContext);
 */
export const ReportContext = createContext<{ report: Report | undefined }>({ report: undefined })
